import { defineMessages } from 'react-intl';

/**
 * Copy for the MCP Bitbucket workspace picker.
 *
 * `placeholder` keeps the `.placeholder.workspace` id it was suffixed with back
 * when this screen ran alongside a second MCP implementation, rather than the
 * shorter `.placeholder`, so existing extractions and translations keep
 * resolving.
 */
export const bitbucketWorkspaceSelectorMessages = defineMessages({
  label: {
    id: 'oauth.mcp.bitbucketWorkspaceSelector.label',
    defaultMessage: 'Bitbucket workspace',
    description: 'Label above the Bitbucket workspace picker',
  },
  placeholder: {
    id: 'oauth.mcp.bitbucketWorkspaceSelector.placeholder.workspace',
    defaultMessage: 'Select',
    description: 'Placeholder text inside the Bitbucket workspace picker',
  },
  noPermissions: {
    id: 'oauth.mcp.bitbucketWorkspaceSelector.noPermissions',
    defaultMessage:
      'No permissions are available for the selected workspace. Select a different workspace to continue.',
    description:
      'Message below the Bitbucket workspace picker when the permission check succeeded but returned no permissions',
  },
  orgConstraint: {
    id: 'oauth.mcp.bitbucketWorkspaceSelector.orgConstraint',
    defaultMessage:
      'Only workspaces from the same organization as your selections can be selected',
    description:
      'Helper below the Bitbucket workspace picker when a site or workspace is already selected, so other-org workspaces are listed but disabled',
  },
  noOrgWorkspaces: {
    id: 'oauth.mcp.bitbucketWorkspaceSelector.noOrgWorkspaces',
    defaultMessage:
      'No workspaces from the same organization as your selections are available',
    description:
      'Helper below the Bitbucket workspace picker when every listed workspace is in a different organization from the current selections',
  },
  singleWorkspaceOrg: {
    id: 'oauth.mcp.bitbucketWorkspaceSelector.singleWorkspaceOrg',
    defaultMessage:
      'Your selection allows only one workspace at a time. Remove the selected workspace to choose another',
    description:
      'Helper below the Bitbucket workspace picker when the selection belongs to an organization that does not allow selecting several workspaces',
  },
  sandboxBlocked: {
    id: 'oauth.mcp.bitbucketWorkspaceSelector.sandboxBlocked',
    defaultMessage:
      'Bitbucket workspaces cannot be selected together with a sandbox site',
    description:
      'Message below the disabled Bitbucket workspace picker when a sandbox site is selected',
  },
  multiSelectHint: {
    id: 'oauth.mcp.bitbucketWorkspaceSelector.multiSelectHint',
    defaultMessage:
      'Choose up to {maxSelected} workspaces from the same organization',
    description:
      'Default helper below the Bitbucket workspace picker when several workspaces can be selected; {maxSelected} is the selection cap',
  },
});
